import React, { useEffect, useState } from 'react'
import { Box, Flex } from 'rebass/styled-components'
import styled from 'styled-components'
import { getUrl } from '../../helpers/Permalinks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChevronRight,
    faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'
import FeedItem from '../general/FeedItem'
import SwiperRender from './SwiperRender'

const Container = styled(Box)`
    margin-top: 6px;
    .swiper-wrapper {
        width: 100%;
        height: 100%;
    }
    .swiper-vertical {
        width: 100%;
        height: 100%;
        overflow: visible;
        .swiper-slide {
            display: block;
            height: auto;
            width: 100%;
        }
    }

    .swiper:not(.swiper-vertical) {
        width: 100%;
        height: 100%;
        overflow: visible;

        .swiper-wrapper {
            margin: 0;
            padding: 0;
        }

        .swiper-slide {
            background-repeat: no-repeat;
            list-style: none;
            width: 240px;
        }

        &.imageOnly {
            .swiper-wrapper {
                padding: ${(props) => props.theme.space.md} 0 0;
            }
        }

        &.vehicle {
            .swiper-wrapper {
                padding: 41px 0 0;
                margin: 0 0 40px;
            }
            .swiper-slide {
                /* height: 300px; */
                height: auto;
                width: 404px;
            }
        }
    }
    .swiper-button-prev,
    .swiper-button-next {
        color: unset;
        width: 35px;
    }
`

const SwiperFilmStrip = ({ onPress, options, slides }) => {
    const [output, setSwiper] = useState(null)
    useEffect(() => {
        if (slides?.docs?.length) {
            const slidesArray = []
            const { collection, docs } = slides
            switch (options.type) {
                case 'imageOnly':
                    Object.entries(docs).map(([key, slide]) => {
                        slidesArray.push(
                            <FeedItem
                                key={`${slide.filename}`}
                                onPress={(e) => fireClick(e, slide)}
                                options={{
                                    mode: options.mode || 'light',
                                    overlay: options.overlay,
                                    imageData: slide,
                                    href: '#',
                                }}
                            >
                                {/* <SwiperLoader /> */}{' '}
                            </FeedItem>
                        )
                        return true
                    })

                    break

                default:
                    Object.entries(docs).map(([key, slide]) => {
                        slidesArray.push(
                            <FeedItem
                                key={`${slide.title}`}
                                onPress={(e) => fireClick(e, slide)}
                                options={{
                                    classes: 'swiper-lazy',
                                    alt: `Learn more about the ${slide.alt}`,
                                    imageData:
                                        slide.media.set.length &&
                                        slide.media.set[0],
                                    href:
                                        getUrl(
                                            collection,
                                            slide.slug,
                                            slide.categories
                                        ) || '#',
                                    headline: slide.title,
                                    caption: slide.caption,
                                    saleProfileStatus: slide.categories,
                                    showTitle: options.showTitle,
                                    showCaption: options.showCaption,
                                    mode: options.mode || 'light',
                                    overlay:
                                        options.data &&
                                        options.data[0] &&
                                        options.data[0].collection ===
                                            'collectionSaleProfiles'
                                            ? true
                                            : false,
                                    categories: slide.categories,
                                }}
                            >
                                {/* <SwiperLoader /> */}{' '}
                            </FeedItem>
                        )
                        return true
                    })
                    break
            }

            if (slidesArray.length) {
                switch (options.direction) {
                    case 'vertical':
                        const navigationVertical = (
                            <Box
                                height='96%'
                                width='40px'
                                mt='sm'
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    right: -8,
                                }}
                            >
                                <Box
                                    height='100%'
                                    width='100%'
                                    className='swiper-scrollbar'
                                >
                                    <Box
                                        height='100%'
                                        bg='aquaLight'
                                        width='4px'
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 'calc(50% - 2px)',
                                        }}
                                    ></Box>
                                    <Flex
                                        height='4px'
                                        className='swiper-scrollbar-drag'
                                        justifyContent='center'
                                    >
                                        <Box
                                            height='100%'
                                            width='70%'
                                            bg='aquaDark'
                                        />
                                    </Flex>
                                </Box>
                            </Box>
                        )

                        setSwiper(
                            <SwiperRender
                                options={{
                                    slidesPerView: 2.3,
                                    loop: false,
                                    direction: 'vertical',
                                    mousewheel: {
                                        forceToAxis: true,
                                    },
                                    spaceBetween: options.spaceBetween ?? 10,
                                    grabCursor: true,
                                    slidesOffsetBefore:
                                        options.slidesOffsetBefore ?? 20,
                                    slidesOffsetAfter:
                                        options.slidesOffsetAfter ?? 0,
                                    slideToClickedSlide: true,
                                    scrollbar: {
                                        el: '.swiper-scrollbar',
                                        draggable: true,
                                        hide: false,
                                        snapOnRelease: true,
                                        dragClass: 'swiper-scrollbar-drag',
                                        dragSize: '4px',
                                    },
                                    slides: slidesArray,
                                    navigationMarkup: navigationVertical,
                                }}
                            />
                        )
                        break
                    default:
                        const navigationHorizontal = (
                            <>
                                {options.navigation && (
                                    <>
                                        <Flex
                                            alignItems='center'
                                            className='swiper-button-prev'
                                            bg='rgba(255, 255, 255, .4)'
                                            sx={{
                                                bottom: 'auto',
                                                cursor: 'pointer',
                                                height: 'calc(100% - 48px)',
                                                left: 0,
                                                position: 'absolute',
                                                top: 'md',
                                                transitionDuration: '150ms',
                                                transitionProperty:
                                                    'background-color',
                                                transitionTimingFunction:
                                                    'ease-out',
                                                willChange: 'background-color',
                                                zIndex: 1,
                                                fontSize: '22px',
                                                '&:after': {
                                                    display: 'none',
                                                },
                                                '&:hover': {
                                                    backgroundColor:
                                                        'aquaMedium',
                                                },
                                            }}
                                        >
                                            <Box px='2'>
                                                <FontAwesomeIcon
                                                    size='xs'
                                                    icon={faChevronLeft}
                                                />
                                            </Box>
                                        </Flex>
                                        <Flex
                                            alignItems='center'
                                            className='swiper-button-next'
                                            bg='rgba(255, 255, 255, .4)'
                                            sx={{
                                                bottom: 'auto',
                                                cursor: 'pointer',
                                                height: 'calc(100% - 48px)',
                                                position: 'absolute',
                                                top: 'md',
                                                transitionDuration: '150ms',
                                                transitionProperty:
                                                    'background-color',
                                                transitionTimingFunction:
                                                    'ease-out',
                                                willChange: 'background-color',
                                                right: 0,
                                                zIndex: 1,
                                                '&:after': {
                                                    content: '""',
                                                },
                                                '&:hover': {
                                                    backgroundColor:
                                                        'aquaMedium',
                                                },
                                            }}
                                        >
                                            <Box px='2'>
                                                <FontAwesomeIcon
                                                    icon={faChevronRight}
                                                />
                                            </Box>
                                        </Flex>
                                    </>
                                )}
                                {!options.loop && (
                                    <Box
                                        variant='container'
                                        height='26px'
                                        width='100%'
                                        className='swiper-scrollbar'
                                        sx={{
                                            background:
                                                'transparent !important',
                                            position: 'relative',
                                        }}
                                    >
                                        <Flex
                                            width='4px'
                                            height='100%'
                                            className='swiper-scrollbar-drag'
                                            alignItems='center'
                                            sx={{
                                                position: 'relative',
                                                zIndex: 1,
                                            }}
                                        >
                                            <Box
                                                width='4px'
                                                height='100%'
                                                bg='aquaDark'
                                            />
                                        </Flex>
                                        <Box
                                            width='100%'
                                            bg='aquaLight'
                                            height='4px'
                                            sx={{
                                                left: 0,
                                                position: 'absolute',
                                                top: 'calc(50% - 2px)',
                                            }}
                                        ></Box>
                                    </Box>
                                )}
                            </>
                        )

                        setSwiper(
                            <SwiperRender
                                onPress={(index) =>
                                    typeof onPress === 'function' &&
                                    onPress(slides.docs[index])
                                }
                                options={{
                                    type: options.type,
                                    tag: 'section',
                                    className: options.type || 'default',
                                    spaceBetween:
                                        parseInt(options.spaceBetween) || 10,
                                    slidesPerView:
                                        parseInt(options.slidesPerView) ||
                                        'auto',
                                    direction: 'horizontal',
                                    mousewheel: {
                                        forceToAxis: true,
                                    },
                                    keyboard: {
                                        enabled: true,
                                    },
                                    scrollbar: {
                                        el: '.swiper-scrollbar',
                                        draggable: true,
                                        hide: false,
                                        snapOnRelease: true,
                                        dragClass: 'swiper-scrollbar-drag',
                                        dragSize: '4px',
                                    },
                                    navigation: {
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                    },
                                    onSlideChange: true,
                                    loop: options.loop || false,
                                    slides: slidesArray,
                                    navigationMarkup: navigationHorizontal,
                                }}
                            />
                        )

                        break
                }
            }
        }
    }, [slides, options])

    const fireClick = (event, slide) => {
        // If not, cancel the click default and send the image src back up the chain.
        if (options.disableClick) {
            event.preventDefault()
            onPress(slide, true)
        }
        // If it has, carry on as normal.
    }

    return (
        <Container
            height='100%'
            width='100%'
        >
            {output}
        </Container>
    )
}

export default SwiperFilmStrip
